import { React, useEffect, useState } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import useLocalStorage from "use-local-storage";
//components
import Menu from "./components/Menu";

//styles
import './styles/index.scss';

// Bootstrap JS is required for some functionality
import "bootstrap/dist/js/bootstrap.bundle.min";

import WorkflowContext from "./workflowContext";


function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

}

function Visualizations() {
    const [cachedWorkflow, setCachedWorkflow] = useLocalStorage('workflow');
    const [workflow, setWorkflow] = useState(cachedWorkflow);
    const [searchParams, setSearchParams] = useSearchParams();
    const [settingParam, setSettingParam] = useState(false);

    const setWorkflowAndCache = (wfString, fromParams = false) => {
        setWorkflow(wfString);
        setCachedWorkflow(wfString);
        if (!fromParams) {
            const newParams = new URLSearchParams(searchParams);
            newParams.set('workflow', wfString);
            setSettingParam(true);
            setSearchParams(newParams);
        }
    }

    // eslint-disable-next-line no-unused-vars
    const [userDetails, setUserDetails] = useState(
        getSessionStorageOrDefault('userDetails', null)
    );

    const found_view_visualization = userDetails?.permissions.find(permission => permission.codename === 'view_visualizations') || false;


    useEffect(() => {
        if (settingParam) {
            setSettingParam(false);
            return;
        } 
        const queryWorkflow = searchParams.get('workflow');
        if (queryWorkflow) setWorkflowAndCache(queryWorkflow, true);
    }, [searchParams])
    
    return (

        <>
        <WorkflowContext.Provider value={workflow}>
            { found_view_visualization === false && <h1 className="h1 m-5"> You do not have permission to view the visualizations module.</h1> }

            { found_view_visualization &&
                <div className="container-fluid">
                    <div className="row">
                        <nav id="sidebarMenu" className="p-0 col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
                            <Menu setWorkflow={setWorkflowAndCache} />
                        </nav>
                        <div className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                            <Outlet />
                        </div>
                    </div>
                </div>
            }
        </WorkflowContext.Provider>
        </>

    );
}


export default Visualizations;